/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "gym-7221ac9c--sprite",
  "use": "gym-7221ac9c--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"gym-7221ac9c--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(0.519 0.529)\"><path d=\"M28.305,9.01l.993-.993a.949.949,0,0,0,0-1.343L28.267,5.642a.95.95,0,0,0-1.343,0l-.993.993L23.136,3.84a.95.95,0,0,0-1.343,0L20.608,5.025a.949.949,0,0,0,0,1.341L18.371,4.129a.95.95,0,0,0-1.343,0L15.843,5.314a.949.949,0,0,0,0,1.343l5.033,5.033L11.69,20.876,6.657,15.843a.95.95,0,0,0-1.343,0L4.129,17.028a.95.95,0,0,0,0,1.343l2.236,2.236a.949.949,0,0,0-1.341,0L3.84,21.793a.95.95,0,0,0,0,1.343l2.794,2.795-.993.993a.949.949,0,0,0,0,1.343L6.673,29.3a.95.95,0,0,0,1.343,0l.994-.994L11.8,31.1a.95.95,0,0,0,1.343,0l1.184-1.184a.95.95,0,0,0,0-1.341l2.236,2.236a.949.949,0,0,0,1.343,0L19.1,29.626a.95.95,0,0,0,0-1.343l-5.033-5.033,9.186-9.186L28.283,19.1a.949.949,0,0,0,1.343,0l1.184-1.184a.95.95,0,0,0,0-1.343l-2.236-2.236a.949.949,0,0,0,1.341,0L31.1,13.147a.95.95,0,0,0,0-1.343Z\" transform=\"translate(0 0)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
